import _defineProperty from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import classNames from 'classnames';
import DotLoading from '../dot-loading';
import { mergeProps } from '../../utils/with-default-props';
import { withNativeProps } from '../../utils/native-props';
import { isPromise } from '../../utils/validate';
var classPrefix = "adm-button";
var defaultProps = {
  color: 'default',
  fill: 'solid',
  block: false,
  loading: false,
  loadingIcon: React.createElement(DotLoading, {
    color: 'currentColor'
  }),
  type: 'button',
  shape: 'default',
  size: 'middle'
};
export var Button = forwardRef(function (p, ref) {
  var _classNames;

  var props = mergeProps(defaultProps, p);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      innerLoading = _useState2[0],
      setInnerLoading = _useState2[1];

  var nativeButtonRef = useRef(null);
  var loading = props.loading === 'auto' ? innerLoading : props.loading;
  var disabled = props.disabled || loading;
  useImperativeHandle(ref, function () {
    return {
      get nativeElement() {
        return nativeButtonRef.current;
      }

    };
  });

  var handleClick = function handleClick(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var promise;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (props.onClick) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              promise = props.onClick(e);

              if (!isPromise(promise)) {
                _context.next = 15;
                break;
              }

              _context.prev = 4;
              setInnerLoading(true);
              _context.next = 8;
              return promise;

            case 8:
              setInnerLoading(false);
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              setInnerLoading(false);
              throw _context.t0;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 11]]);
    }));
  };

  return withNativeProps(props, React.createElement("button", {
    ref: nativeButtonRef,
    type: props.type,
    onClick: handleClick,
    className: classNames(classPrefix, props.color ? "".concat(classPrefix, "-").concat(props.color) : null, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-block"), props.block), _defineProperty(_classNames, "".concat(classPrefix, "-disabled"), disabled), _defineProperty(_classNames, "".concat(classPrefix, "-fill-outline"), props.fill === 'outline'), _defineProperty(_classNames, "".concat(classPrefix, "-fill-none"), props.fill === 'none'), _defineProperty(_classNames, "".concat(classPrefix, "-mini"), props.size === 'mini'), _defineProperty(_classNames, "".concat(classPrefix, "-small"), props.size === 'small'), _defineProperty(_classNames, "".concat(classPrefix, "-large"), props.size === 'large'), _defineProperty(_classNames, "".concat(classPrefix, "-loading"), loading), _classNames), "".concat(classPrefix, "-shape-").concat(props.shape)),
    disabled: disabled,
    onMouseDown: props.onMouseDown,
    onMouseUp: props.onMouseUp,
    onTouchStart: props.onTouchStart,
    onTouchEnd: props.onTouchEnd
  }, loading ? React.createElement("div", {
    className: "".concat(classPrefix, "-loading-wrapper")
  }, props.loadingIcon, props.loadingText) : React.createElement("span", null, props.children)));
});